import { useI18n } from 'vue-i18n'
import { Parameter } from '@/enums/Parameter'
import { defaultParametersUnits } from '@/util/defaultParametersUnits'

function useParameterLabel() {
  const { t, te } = useI18n()

  const unitKeyMap: Record<string, string> = {
    'ml/min/1.73m²': 'ml/min/1,73m²'
  }

  function getParameterDefaultUnit(parameter: Parameter): string {
    const foundParameter = defaultParametersUnits.find((item) => item.parameter === parameter)

    if (!foundParameter?.translationUnitKey) {
      return ''
    } else {
      return getParameterUnit(foundParameter.translationUnitKey)
    }
  }

  function getLabelWithDefaultUnit(parameter: Parameter, useAbbreviation: boolean = false): string {
    const foundParameter = defaultParametersUnits.find((item) => item.parameter === parameter)

    if (!foundParameter) {
      return ''
    } else {
      return formatLabelWithUnit(parameter, foundParameter.translationUnitKey, useAbbreviation)
    }
  }

  function formatLabelWithUnit(
    parameter: Parameter,
    unit: string | null,
    useAbbreviation: boolean = false
  ): string {
    const unitLabel = unit ? getParameterUnit(unit) : ''
    if (useAbbreviation) {
      return `${getParameterAbbreviation(parameter)} [${unitLabel}]`
    }

    return `${getParameterLabel(parameter)} [${unitLabel}]`
  }

  function getParameterLabel(parameter: Parameter): string {
    return getTranslatedValue(`parameters.${parameter}.fullName`)
  }

  function getParameterUnit(unit: string): string {
    return getTranslatedValue(unit)
  }

  function getParameterAbbreviation(parameter: Parameter): string {
    return getTranslatedValue(`parameters.${parameter}.abbreviation`)
  }

  function getTranslatedValue(key: string): string {
    const mappedKey = unitKeyMap[key]

    if (mappedKey && te(mappedKey)) {
      return t(mappedKey)
    }

    return te(key) ? t(key) : ''
  }

  return {
    getParameterLabel,
    getParameterUnit,
    getParameterAbbreviation,
    getLabelWithDefaultUnit,
    getParameterDefaultUnit
  }
}

export default useParameterLabel
